(function ($) {

  productAccordion();
  TabList();
  MegaMenu();

  AOS.init({
    duration: 1000, 
    once: true
  });

})(jQuery);

function productAccordion() {

  $(".section__accordion__head").click(function() {
      
      if ($(this).next(".section__accordion__body").is(':visible')) {
          $(this).next(".section__accordion__body").slideUp(300);
          $(this).children(".section_icon_wrapper, .apps__icon__wrapper").removeClass('active');
      } else {
          $(this).next(".section__accordion__body").slideDown(300);
          $(this).children(".section_icon_wrapper, .apps__icon__wrapper").addClass('active');
      }
  });

  $('.anchor-link').click(function(e){
    e.preventDefault();
    var target = $($(this).attr('href'));
    if(target.length){
      var scrollTo = target.offset().top -50;
      $('body, html').animate({scrollTop: scrollTo+'px'}, 500);
    }
  });
  
}

function TabList() {
	$(document).on('click', '.TabList .TabList__Item', function() {
    $('.ProductListWrapper .product-grid').slick('setPosition').slick();
    var $this = $(this),
        $tabList = $this.parents('.TabList'),
        index = $this.closest('.TabList__Item').index();
    
    $tabList.children().eq(index).addClass('is-active').siblings().removeClass('is-active');
    $tabList.next().children().eq(index).addClass('is-active').siblings().removeClass('is-active');
  });


  $('.ShopTheLook__ItemButton').click(function() {
    var myEm = $(this).attr('data-my-element');
    $('.ShopTheLook__PopUp[data-my-element = '+myEm+']').addClass('is-active');
    $('.ShopTheLook .slick-list').addClass('is-scale');
  });

  $('.ShopTheLook__PopUpHeader .Popover__Close').click(function() {
    $('.ShopTheLook__PopUp').removeClass('is-active');
    $('.ShopTheLook .slick-list').removeClass('is-scale');
  });


}

function MegaMenu() {
	$(".HorizontalList .HorizontalList__Item").hover(
    function () {
      $(this).addClass("is-expanded");
    },
    function () {
      $(this).removeClass("is-expanded");
    }
  );

  // $(".Header__MainNav .HorizontalList__Item").mouseleave(function(){
  //   $('.MegaMenu__Item__ListItem:first-child').addClass('active');
  //   $('.MegaMenu__Push:first-child').show();
  // });

  // $('.MegaMenu__Item__ListItem:first-child').addClass('active');
  // $('.MegaMenu__Push').hide();
  // $('.MegaMenu__Push:first-child').show();

  // $('.MegaMenu__Item__ListItem').mouseenter(function(){
  //   $('.MegaMenu__Item__ListItem').removeClass('active');
  //   $('.MegaMenu__Push').hide();
    
  //   var activeTab = $(this).find('a').attr('data-toggle');
  //   $(activeTab).show();
  // });

  var HeadingTabbers = $('.HeadImage__tabbers .Linklist__Item');
  HeadingTabbers.on('mouseenter', function(){
      var me = $(this),
      image_target = me.data('image-target'),
      imageElemWrap = $('.HeadImage__switcher'),
      menuTabsElemWrap = $('.menuTabs'),
      imageElemAll = imageElemWrap.children('.MegaMenu__Push'),
      imageElemTarget = imageElemWrap.find('[data-id="'+image_target +'"'),
      menuTabsElemTarget = $('.menuTabs[data-line="'+image_target +'"]');

      $('.HeadImage__tabbers > .Linklist__Item').removeClass('active');
      me.addClass('active');

      menuTabsElemWrap.removeClass('active');
      menuTabsElemTarget.addClass('active');

      imageElemAll.not('[data-id="'+image_target +'"]').hide();
      imageElemAll.removeClass('active__image');
      imageElemTarget.addClass('active__image').fadeIn();
  });

  var HeadingTabbers = $('.menuTabs .Linklist__Item');
  HeadingTabbers.on('mouseenter', function(){
  var me = $(this),
      image_target = me.data('img');

      $('.active__image img').attr('src', image_target);
  });

  
  $('.menu-drawer-container .header__icon').click(function () {
    $('html').toggleClass('active');
  });
}
